
import { BaseVue } from "@/mixin/index";
import { TableContainer } from "@/core/table/";
import partyorgSelect from "@/views/module/partyOrganization/components/partyorgSelect.vue";
import { TableColumnConfig, TableToolConfig } from "@/core/table/types";

export default {
  name: "ExportPartyorg",
  
  mixins: [BaseVue],
  
  components: {
    TableContainer,
    partyorgSelect
  },
  
  data() {
    return {
      // table 头
      containerTableColumns: [
        {
          prop: "title",
          label: "组织名",
          width: "330px"
        },
        {
          prop: "ptitle",
          label: "上级组织"
        }
      ] as TableColumnConfig[],
      // 基础地址
      containerBaseUrl: "/standard/partyorg",
      // api的基础地址
      containerServerUrl: "/api/manager/partyorg",
      // table config 设置
      tableToolConfig: {
        canEdit: false,
        canRecover: false,
        canDelete: false,
        canDisable: false
      } as TableToolConfig
    };
  },
  
  methods: {
    // $emit 筛选内容改变
    onStudyClassValueChanged(pid: string) {
      (this.$refs.TableContainer as any).updatePid(pid);
    }
  },
  
  mounted() {
    // 生命周期钩子
  }
};
